import React from "react";

const TimePeriodFilter = ({ selectedPeriod, onPeriodChange }) => {
  const periods = [
    { value: "daily", label: "Daily", icon: "fa-calendar-day" },
    { value: "weekly", label: "Weekly", icon: "fa-calendar-week" },
    { value: "monthly", label: "Monthly", icon: "fa-calendar-alt" },
    { value: "quarterly", label: "Quarterly", icon: "fa-calendar" },
    { value: "yearly", label: "Yearly", icon: "fa-calendar-check" },
  ];

  return (
    <div className="time-period-filter">
      {periods.map((period) => (
        <button
          key={period.value}
          className={`period-btn ${selectedPeriod === period.value ? "active" : ""}`}
          onClick={() => onPeriodChange(period.value)}
          title={period.label}
        >
          <i className={`far ${period.icon} me-1`}></i>
          {period.label}
        </button>
      ))}
    </div>
  );
};

export default TimePeriodFilter;
